module.exports = __webpack_public_path__ + "img/Logo_blue@2x.9de4daf3.png";